import React, { useContext, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Breadcrumbs, Button, Loading, PageBody, PageHeader, PageTitle, Section } from 'modules';
import ButtonTransmitReport from 'components/ButtonTransmitReport';
import ButtonAcceptToSign from 'components/ButtonAcceptToSign';
import UploadIdentityCard from 'components/UploadIdentityCard';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectConsultantAccess,
  selectMeetingModeOffline,
  selectOnlineForm,
  selectOnlineFormContract,
  selectOnlineFormData,
  setInvalidateOnlineForm,
} from 'stores/onlineForm/onlineForm';
import { Trans, useTranslation } from 'react-i18next';
import Partner from './components/Partner';
import ContentByContract from './contents/ContentByContract';

const OnlineFormSummary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const wsContext = useContext(WebsocketContext);

  const form = useSelector(selectOnlineForm);
  const formData = useSelector(selectOnlineFormData);
  const contract = useSelector(selectOnlineFormContract);
  const isConsultantAccess = useSelector(selectConsultantAccess);
  const isOfflineMode = useSelector(selectMeetingModeOffline);

  const onSubmitSign = () => {
    wsContext.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
  };

  useEffect(() => {
    dispatch(setInvalidateOnlineForm(true));
  }, [dispatch]);

  if (!contract || !form) {
    return <Loading />;
  }

  return (
    <>
      <PageHeader>
        <Breadcrumbs>
          <Breadcrumbs.Item to="/" active={false}>
            <Trans>ONLINE_FORMS.SUMMARY</Trans>
          </Breadcrumbs.Item>
        </Breadcrumbs>
      </PageHeader>
      <Container className="m-0">
        <PageTitle title={t('ONLINE_FORMS.SUMMARY')} />

        <PageBody className="mt-2" style={{ maxWidth: 800 }}>
          <Section className="mb-3" style={{ color: 'black' }}>
            <ContentByContract />
          </Section>
          {contract && <UploadIdentityCard contract={contract} />}
          <Row>
            <Col className="text-right">
              <Partner />
              {contract && isConsultantAccess && <ButtonTransmitReport />}
              {/* co když je platba již zaplacena */}
              {/* {contract &&
                <ButtonContractPay form={form} contract={contract} disabled={isClientMode()} />} */}
              {contract && form && form.signIn === null && (
                <ButtonAcceptToSign
                  data={{
                    form: { id: form.id },
                    contractId: contract.id,
                    productId: formData.productId,
                    mobil: formData?.mobil || '',
                  }}
                  disabled={isConsultantAccess && !isOfflineMode}
                  onSubmit={onSubmitSign}
                />
              )}
              {form && form.signIn !== null && (
                <Button variant={'secondary'} className="ml-1" disabled={true}>
                  Objednávka už bola podpísaná
                </Button>
              )}
            </Col>
          </Row>
        </PageBody>
      </Container>
    </>
  );
};

export default OnlineFormSummary;
